const en = {
  // App brand
  brand: 'HisabFlow',
  brandTagline: 'BUSINESS OPERATING SYSTEM',

  // Common
  cancel: 'Cancel',
  save: 'Save',
  saveChanges: 'Save Changes',
  delete: 'Delete',
  edit: 'Edit',
  close: 'Close',
  back: 'Back',
  search: 'Search',
  loading: 'Loading...',
  actions: 'Actions',
  status: 'Status',
  paymentMethod: 'Payment Method',
  cash: 'Cash',
  online: 'Online',
  attachment: 'Attachment',
  view: 'View',
  date: 'Date',
  time: 'Time',
  name: 'Name',
  phone: 'Phone',
  cnic: 'CNIC',
  area: 'Area',
  areaPH: 'Enter area / region',
  areaFilter: 'Filter by area',
  allAreas: 'All Areas',
  areaWiseSummary: 'Area-wise Summary',
  selectArea: '-- Select Area --',
  addNewArea: 'Add New Area',
  outstanding: 'Outstanding',
  amount: 'Amount',
  description: 'Description',
  category: 'Category',
  type: 'Type',
  total: 'Total',
  none: 'N/A',
  yes: 'Yes',
  no: 'No',
  allTime: 'All Time',
  refresh: 'Refresh',
  printReport: 'Print Report',
  printSavePDF: 'Print / Save PDF',
  printBarcode: 'Print Barcode',
  generateBarcode: 'Generate Barcode',
  labelQuantity: 'Number of Labels',
  print: 'Print',
  closeBtn: '← Close',
  generatedBy: 'Generated by HisabFlow',
  generatingPdf: 'Preparing PDF...',
  pdfDownloadedShareWA: 'Report PDF downloaded! Attach it in the opened WhatsApp chat.',

  // Auth / Login
  shopLogin: 'Shop Login',
  registerBusiness: 'Register Business',
  signInToShop: 'Sign in to your Shop',
  registeredPhone: 'Registered Phone Number',
  fourDigitPIN: '4-Digit Organization PIN',
  loginBtn: 'Access My Ledger >',
  loginHint: 'Use your registered phone & assigned PIN',
  loginNoAccess: "Don't have access? Register your business or contact your admin.",
  rememberMe: 'Remember Me',

  // Email OTP sign-in
  signInWithEmail: 'Sign in with email instead',
  emailSignIn: 'Sign in with Email',
  emailSignInHint: 'We will email you a 6-digit login code',
  emailAddress: 'Email address',
  sendCode: 'Send code',
  sendingCode: 'Sending...',
  sixDigitCode: '6-digit login code',
  verifyAndSignIn: 'Verify & sign in',
  resendCode: 'Resend code',
  resendIn: 'Resend in {s}s',
  otpSent: 'If that address is registered, a login code has been sent.',
  otpSentToLabel: 'Enter the 6-digit code we sent to {email}',
  otpCodeIncomplete: 'Please enter all 6 digits.',
  changeEmail: 'Change email',
  usePhoneAndPin: 'Use phone & PIN instead',
  emailSignInUnavailable: "Email sign-in isn't set up on this server yet. Please use your phone & PIN.",
  registerTitle: 'Register Your Business',
  registerSubtitle: 'Submit your details for admin approval',
  shopName: 'Business/Shop Name',
  ownerName: 'Owner Full Name',
  contactEmail: 'Contact Email',
  mobilePhone: 'Mobile Phone Number',
  shopAddress: 'Shop Address (Optional)',
  subscriptionPlan: 'Subscription Plan',
  plan2Days: '2 Days Trial',
  plan1Month: '1 Month',
  plan1Year: '1 Year',
  plan3Years: '3 Years',
  planLifetime: 'Lifetime',
  submitRegistration: 'Submit Registration >',
  regPendingTitle: 'Registration Submitted!',
  regPendingMsg: 'Your subscription request is pending admin review. Once approved, the admin will share your 4-digit PIN to access the app.',
  goToLogin: 'Go to Login',

  // Admin Portal
  adminPortal: 'Admin Portal',
  adminSubtitle: 'Manage registrations, approvals & databases',
  adminBusinessTitle: 'Business Registration & Database Management',
  adminUsername: 'Admin Username',
  adminPassword: 'Admin Password',
  accessAdmin: 'Access Admin Dashboard >',
  pendingRequests: 'Pending Requests',
  renewalRequests: 'Renewal Requests',
  allOrganizations: 'All Organizations',
  backups: 'Backups',
  totalRegistered: 'Total Registered',
  pendingApproval: 'Pending Approval',
  activeShops: 'Active Shops',
  deactivated: 'Deactivated',
  backupsLogged: 'Backups Logged',
  dbSize: 'DB Size (Total)',
  noPendingReqs: 'No pending registration requests',
  noRenewalReqs: 'No renewal requests',
  searchOrgs: 'Search by name, phone or owner...',
  noOrgs: 'No organizations registered yet.',
  owner: 'Owner',
  phone: 'Phone',
  email: 'Email',
  submitted: 'Submitted',
  approve: 'Approve',
  reject: 'Reject',
  deactivate: 'Deactivate',
  activate: 'Activate',
  reApprove: 'Re-approve',
  approveRenewal: 'Approve Renewal',
  pinRequired: 'Organization PIN (4 digits)',
  approveCreateDB: 'Approve & Create Database',
  currentPlan: 'Current Plan',
  ended: 'Ended',
  requested: 'Requested',
  notSet: 'not set',
  selectOrgHint: 'Select an organization from All Organizations tab...',
  runBackup: 'Run Manual Backup',
  download: 'Download',
  logOutAdmin: 'Log Out Admin',
  backupType: '{type} Backup',
  renewBtn: 'Approve Renewal',
  rejectBtn: 'Reject',
  pendingBadge: 'PENDING',
  renewalBadge: 'RENEWAL',
  approvedBadge: 'APPROVED',
  deactivatedBadge: 'DEACTIVATED',

  // Lock Screen
  securityLock: 'Security Lock',
  lockHint: 'Type business ledger PIN code to access books.',
  loggedInAs: 'Logged in as',
  unlockBtn: 'Unlock Ledger',
  verifying: 'Verifying...',

  // Subscription Expired
  subExpired: 'Subscription Expired',
  subExpiredMsg: 'Your subscription for {name} ended on {date}.',
  subExpiredHint: 'Request a renewal from the admin to continue using the app.',
  subExpiredPending: 'A renewal request has already been sent. Please wait for admin approval.',
  requestRenewal: 'Request Renewal',
  backToLogin: 'Back to Login',

  // Header / Nav
  dashboard: 'Dashboard',
  customers: 'Customers',
  suppliers: 'Suppliers',
  cashBook: 'Cash Book',
  bank: 'Bank',
  bankAccounts: 'Bank Accounts',
  bankAccount: 'Bank Account',
  bankName: 'Bank Name',
  selectBankName: '-- Select Bank --',
  addBankDetails: 'Add Bank Details',
  hideBankDetails: 'Hide',
  bankTransactions: 'Bank Transactions',
  accountTitle: 'Account Title',
  accountNumber: 'Account Number',
  iban: 'IBAN',
  paymentReference: 'Payment Reference',
  branch: 'Branch',
  openingBalance: 'Opening Balance',
  currentBalance: 'Current Balance',
  activeAccount: 'Active Account',
  addBankAccount: 'Add Bank Account',
  editBankAccount: 'Edit Bank Account',
  bankTransactionType: 'Transaction Type',
  transfer: 'Transfer',
  adjustment: 'Adjustment',
  deposit: 'Deposit',
  withdrawal: 'Withdrawal',
  chooseBankAccount: 'Choose bank account',
  selectBankAccount: '-- Select Bank Account --',
  bankAccountAdded: 'Bank account added.',
  bankAccountUpdated: 'Bank account updated.',
  bankAccountDeleted: 'Bank account deleted.',
  incomeExpense: 'Income & Expense',
  products: 'Products',
  stockInventory: 'Stock / Inventory',
  staffSalaries: 'Staff & Salaries',
  billBook: 'Bill Book',
  viewLedger: 'Ledger',
  settings: 'Settings',

  // Manage Users Tab
  loadingUsers: 'Loading users...',
  addUser: 'Add User',
  inactive: 'Inactive',
  you: 'You',
  roleLabel: 'Role:',
  pinLabel: 'PIN:',
  notSet: 'Not set',
  deactivate: 'Deactivate',
  activate: 'Activate',
  editUser: 'Edit User',
  newPinHint: 'New PIN (leave blank to keep current)',
  pinHint: 'PIN (4 digits)',
  adminRole: 'Admin (Full Access)',
  managerRole: 'Manager',
  cashierRole: 'Cashier (Cash + Ledger)',
  viewerRole: 'Viewer (Read Only)',
  saveChanges: 'Save Changes',
  nameLabel: 'Name',
  deactivateConfirm: 'Deactivate this member?',
  activateConfirm: 'Activate this member?',
  addUsers: "Add Users",
  manageUsers: "Manage Users",
  activityLog: "Activity Log",
  switchUser: "Switch User",
  switchOrg: 'Switch Organization',
  logOut: 'Log Out',

  // Dashboard
  dashTitle: 'Dashboard Overview',
  customerReceivables: 'Customer Receivables',
  youGet: 'You Get',
  fromCustomerTabs: 'From customer ledger tabs',
  supplierPayables: 'Supplier Payables',
  youGive: 'You Give',
  fromSupplierTabs: 'From supplier ledger statements',
  cashBalance: 'Available Cash Balance',
  inSafe: 'In Safe',
  cashFlow: 'Cash Inflow - Outflow',
  walkInSales: 'Walk-in Sales',
  walkInSalesChip: 'Cash Sales',
  walkInSalesDesc: 'Invoices without a linked customer',
  lowStock: 'Low Stock Warning',
  lowStockMsg: 'There are {count} items in inventory running below critical safety limits.',
  quickOps: 'Quick Business Operations',
  newCustomerSupplier: 'New Customer / Supplier',
  createInvoice: 'Create Invoice',
  addExpenseIncome: 'Add Expense/Income',
  viewStock: 'View Stock',
  viewBillBook: 'View Bill Book',
  incomeVsExpense: 'Income vs Expense',
  net: 'Net',
  financialPosition: 'Financial Position',

  // Dashboard Quick Actions
  staffDirectoryTitle: 'Staff Directory',
  productCatalog: 'Product Catalog',
  invoiceBuilder: 'Invoice Builder',
  performanceReports: 'Performance Reports',

  // Customers
  searchCustomers: 'Search Customers name or phone...',
  noCustomers: 'No customers logged.',
  addCustomer: 'Add Customer',
  balanceDue: 'Balance Due',
  paying: 'Paying',

  // Suppliers
  searchSuppliers: 'Search Suppliers name or phone...',
  noSuppliers: 'No suppliers logged.',
  addSupplier: 'Add Supplier',
  itemsSupplied: 'Items Supplied',

  // Customer/Supplier Ledger
  backToList: '← Back to List',
  whatsappReminder: 'WhatsApp Reminder',
  printStatement: 'Print Statement',
  receivableGet: 'Receivable (Get)',
  payableGive: 'Payable (Give)',
  clear: 'Clear',
  logNewEntry: 'Log New Entry',
  ledGave: 'Gave (-)',
  ledGot: 'Got (+)',
  debit: 'Debit',
  credit: 'Credit',
  genericEntry: 'Generic Entry',
  noTransactions: 'No transactions logged for this party.',
  entryNumber: '#',
  youGaveNeg: 'You Gave (−)',
  youGotPos: 'You Got (+)',
  youPaidNeg: 'You Paid (−)',
  theySuppliedPos: 'They Supplied (+)',
  gavePayNeg: 'Gave / Pay (−)',
  gotSuppliedPos: 'Got / Supplied (+)',

  // Cash Book
  logCashEntry: 'Log Cash Entry',
  cashStatements: 'Cash Statements',
  searchByDetails: 'Search by details...',
  cashIn: 'Cash In',
  cashOut: 'Cash Out',
  noCashEntries: 'No cash flow statements recorded.',
  cashInBtn: 'Cash In (+)',
  cashOutBtn: 'Cash Out (-)',
  cashFlowLabel: 'Cash Flow',

  // Income & Expense
  addExpenseIncomeTitle: 'Add Expense/Income',
  ieSearch: 'Search by category or description...',
  noLogs: 'No logs found.',
  income: 'Income',
  expense: 'Expense',
  salesIncome: 'Sales Income',
  staffSalary: 'Staff Salary',
  shopUtilities: 'Shop Utilities',
  generalExpenses: 'General Expenses',
  customCategory: '+ Custom Category...',
  netProfitLoss: 'NET PROFIT / LOSS',

  // Products / Stock
  searchInventory: 'Search inventory items...',
  noProducts: 'No products in catalog.',
  addProduct: 'Add Product',
  productName: 'Product Name',
  skuBarcode: 'SKU / Barcode',
  unit: 'Unit Quantity',
  purchasePrice: 'Purchase Price (Rs.)',
  salePrice: 'Retail Price (Rs.)',
  openingStock: 'Stock',
  lowStockAlert: 'Low Stock Alert Qty',
  optional: 'Optional',
  expirationDate: 'Expiration Date',
  expiryDateOptional: 'Expiration Date (Optional)',
  nameOrSku: 'Name / SKU',
  costPrice: 'Purchase Price',
  sellPrice: 'Sell Price',
  stockStatus: 'Stock Status',
  totalValue: 'Stock Value (Cost)',
  inStock: 'In Stock',
  lowStock: 'Low Stock',
  outOfStock: 'Out of Stock',
  restock: 'Restock',
  currentStock: 'Current Stock',
  addQuantity: 'Add Quantity',
  productRestocked: 'Added {qty} to {name}!',

  // Staff & Salaries
  staffTitle: 'Staff & Salary Management',
  staffSubtitle: 'Log attendance, manage base salaries and track payouts.',
  staffSearch: 'Search staff or salary...',
  addEmployee: 'Add Employee',
  paySalaries: 'Pay Salaries',
  logAttendance: 'Log Daily Attendance',
  attendanceDateHint: 'Select date and mark status for each employee.',
  present: 'PRESENT',
  absent: 'ABSENT',
  leave: 'LEAVE',
  staffDirectory: 'Staff Directory',
  employeesOf: '{filtered} of {total} employees',
  filterByName: 'Filter by name, phone, CNIC...',
  salaryType: 'Salary Type',
  baseSalary: 'Base Salary',
  salaryPayroll: 'Salary Payroll History',
  searchByEmployee: 'Search by employee name...',
  period: 'Period',
  basic: 'Basic',
  allowances: 'Allowances',
  deductions: 'Deductions',
  netPaid: 'Net Paid',
  salarySlip: 'Salary Slip',
  employee: 'Employee',
  monthly: 'Monthly',
  daily: 'Daily',
  hourly: 'Hourly',
  paid: 'PAID',
  unpaid: 'UNPAID',
  noStaffFound: 'No staff match "{query}".',
  noStaffYet: 'No staff added yet. Click "Add Employee" to get started.',
  noPayrollYet: 'No payouts logged yet. Click "Pay Salaries" to record a salary disbursement.',
  noPayrollMatch: 'No payroll records match "{query}".',
  whatsapp: 'WhatsApp',


  // Bill Book
  purchaseInvoice: 'Purchase Invoice',
  piLabel: 'PI',
  supplierDetails: 'Supplier Details',
  backToSuppliers: 'Back to Suppliers',
  purchaseInvoiceCreatedMsg: 'Purchase Invoice created! Ready to print.',
  invoiceBuilderTitle: 'Invoice Builder',
  selectCustomer: 'Select Customer',
  chooseCustomer: '-- Choose Customer --',
  invoiceNumber: 'Invoice Number',
  dateOfIssue: 'Date of Issue',
  lineItems: 'Line Items',
  chooseProduct: '-- Choose Product --',
  orTypeItem: 'Or type manual item name...',
  searchCustomerPH: 'Search by name or phone...',
  searchProductPH: 'Search product by name or SKU...',
  noResults: 'No results found',
  pickFromContacts: 'Import from Contacts (.vcf)',
  contactsAPINotSupported: 'Device contacts not supported on this browser. Try Chrome on Android.',
  contactImportFailed: 'Failed to import contact',
  noContactsFound: 'No contacts found in file',
  selectContact: 'Select a Contact',
  contactsFound: 'contacts found',
  unknown: 'Unknown',
  qty: 'Qty',
  rate: 'Rate',
  addItemRow: 'Add Row',
  finalizePrint: 'Finalize & Print Invoice',
  placeOrder: 'Place Order',
  saveAndPrint: 'Save & Print',
  itemDescription: 'Item / Description',
  unitPrice: 'Unit Price',
  subtotal: 'Subtotal',
  noInvoices: 'No invoices created yet.',
  searchByNameOrPhone: 'Search by name or phone...',
  invoiceHistory: 'Invoice History',
  createInvoice: 'Create Invoice',
  invoiceDeleted: 'Invoice deleted successfully.',
  invoiceUpdated: 'Invoice updated successfully.',
  deleteInvoice: 'Delete invoice {{number}}?',
  editInvoice: 'Edit Invoice',
  createFirst: 'Create your first invoice to get started.',

  // Invoice Print
  invoiceReceipt: 'INVOICE RECEIPT',
  cashCustomer: 'Cash Customer',
  valuedCustomer: 'Valued Customer',
  invoice: 'INVOICE',
  invoiceSummary: 'Invoice Summary',
  totalRevenue: 'Total Revenue',

  // Settings
  settingsTitle: 'Settings',
  subPlan: 'Subscription Plan',
  currentPlanLabel: 'Current Plan:',
  subActive: 'Subscription is active.',
  expiresOn: 'Expires on {date} ({days} day(s) left)',
  expiredOn: 'Expired on {date}',
  subExpiringSoon: 'Your plan is expiring soon. Renew to avoid interruption.',
  subExpiredRestrict: 'Your access may be restricted. Please renew your plan.',
  subActiveFull: 'Your subscription is active.',
  requestPlanRenewal: 'Request Plan Renewal',
  renewalRequested: 'Renewal Requested — Awaiting Admin',
  changePin: 'Change PIN Code',
  changePinDesc: 'Your current PIN is used to unlock the ledger. Changing it will update the PIN shown in the admin portal.',
  currentPIN: 'Current PIN',
  newPIN: 'New PIN',
  confirmNewPIN: 'Confirm New PIN',
  changePinBtn: 'Change PIN',
  enterCurrentPIN: 'Enter current PIN',
  enterNewPIN: 'Enter new 4-digit PIN',
  confirmNewPINPH: 'Confirm new PIN',

  // Renewal Plan Modal
  selectRenewalPlan: 'Select Renewal Plan',
  selectRenewalDesc: 'Choose a subscription plan to request renewal from admin.',
  bestForTrying: 'Best for trying out',
  mostPopular: 'Most popular — save more',
  bestValue: 'Best value — long term',
  trialDesc: 'Quick 2-day trial',
  sendRequest: 'Send Request',

  // Modals
  addNewProduct: 'Add New Product',
  addToCatalog: 'Add to Catalog',
  productPhoto: 'Product Photo',
  browsePhoto: 'Browse Photo',
  replacePhoto: 'Replace Photo',
  gallery: 'Gallery',
  productGallery: 'Product Gallery',
  selectFromGallery: 'Select from Gallery',
  noPhotosYet: 'No product photos yet. Add photos when creating or editing products.',
  allCategories: 'All Categories',
  productType: 'Product Type',
  productTypePH: 'e.g. Bakery, Electronics, Grocery',
  selectProductType: '-- Select Type --',
  addNewProductType: 'Add New Type',
  allTypes: 'All Types',
  logEntry: 'Log Entry: {name}',
  logCashEntryTitle: 'Log Cash Entry',
  logSalaryTitle: 'Log Salary Disbursement',
  editParty: 'Edit Party',
  editTransaction: 'Edit Transaction',
  editCashEntry: 'Edit Cash Entry',
  editOperation: 'Edit Operation',
  editProduct: 'Edit Product',
  editStaff: 'Edit Staff Member',
  editCompany: 'Edit Company Profile',
  confirmDelete: 'Confirm Delete',
  transactionType: 'Transaction Type',
  address: 'Address',
  cnicOptional: 'CNIC (Optional)',
  saveParty: 'Save Party',
  logOperationsFlow: 'Log Operations Flow',
  logRecordBtn: 'Log Record',
  shopRent: 'Shop Rent',
  electricityBill: 'Electricity Bill',
  packagingMaterial: 'Packaging Material',
  rawIngredients: 'Raw Ingredients',
  staffSalaryOption: 'Staff Salary',
  salesReturn: 'Sales Return',
  customCatOption: '+ Type Custom Category...',
  cashFlow: 'Cash Flow',
  detailsLabel: 'Details',
  chooseEmployeeTitle: 'Choose Employee',
  unpaidAccrued: 'Unpaid / Accrued',
  paidOutDirectly: 'Paid Out Directly',
  addItemToInventory: 'Add an item to your inventory catalog',
  updateEmployeeInfo: 'Update employee information',
  unitType: 'Unit Type',
  stockQty: 'Stock Quantity',
  unitsQty: 'Units Quantity (Pieces per Pack)',
  unitsQtyHelper: 'Number of pieces in one pack/box (e.g. 12). Use 1 if the product is a single unit.',
  packCost: 'Pack Cost',
  packRetail: 'Pack Retail',
  piecesPerPackLabel: 'Pieces per Pack',
  onePackEquals: '1 pack = {n} pieces',
  stockShort: 'Stock',
  insufficientStock: 'Not enough stock for these items:',
  needsQty: 'needs {n} pcs',
  onlyQty: 'only {n} pcs in stock',
  continueAnyway: 'Continue anyway?',
  lowStockLimit: 'Low Stock Limit',
  qtyType: 'Qty Type',
  qtyTypePack: 'Packs',
  qtyTypePiece: 'Pieces',
  packs: 'packs',
  pack: 'pack',
  piece: 'piece',
  pieces: 'pieces',
  pcSingular: 'pc',
  pcPlural: 'pcs',
  retailValue: 'Retail Value',
  expectedProfit: 'Expected Profit',
  activeOrg: 'Active Organization',
  logoutConfirm: 'Log out from this organization?',
  invoiceCreatedMsg: 'Invoice created! Ready to print.',
  invoiceErrorMsg: 'Error creating invoice: {error}',
  selectOrgBackupsHint: 'Select an organization from All Organizations tab to manage its backups.',
  noBackupsYet: 'No backups yet. Click "Run Manual Backup" to create the first one.',
  runManualBackup: 'Run Manual Backup',
  backingUp: 'Creating backup...',
  backupCompleted: 'Backup completed successfully!',
  backupFailed: 'Backup failed.',
  autoBackupCompleted: 'Auto backup completed for all organizations.',
  dataBackup: 'Data Backup',
  lastBackup: 'Last backup',
  noBackupYet: 'No backup taken yet',
  backupDescription: 'Your data is automatically backed up daily. Admin can also create manual backups anytime.',
  size: 'Size',
  restore: 'Restore',
  restoreConfirm: 'Are you sure you want to restore this backup? This will OVERWRITE all current data for this organization.',
  restoreCompleted: 'Database restored successfully!',
  restoreFailed: 'Restore failed.',
  recycleBin: 'Recycle Bin',
  recycleBinEmpty: 'Recycle bin is empty. Deleted items will appear here.',
  itemRestored: 'Item restored successfully.',
  permanentDeleteConfirm: 'This will permanently delete this item. This action cannot be undone.',
  itemPermanentlyDeleted: 'Item permanently deleted.',
  deleteFailed: 'Delete failed.',
  price: 'Price',
  subtotalLabel: 'Subtotal',
  itemLabel: 'Item',
  grandTotal: 'Grand Total',
  purchaseHistory: 'Purchase History',
  paidAmount: 'Paid Amount',
  remainingBalance: 'Remaining',
  runningBalance: 'Balance',
  billTo: 'BILL TO:',
  dateOfIssueLabel: 'DATE OF ISSUE:',
  chooseItem: 'Choose item...',
  supplierLabel: 'Supplier',
  itemsLabel: 'Items',
  discount: 'Discount',
  discountMode: 'Discount Mode',
  discountModeDesc: 'How a discount is entered on an invoice.',
  discountWholeInvoice: 'Whole Invoice',
  discountWholeInvoiceDesc: 'One discount box for the invoice, as before.',
  discountPerItem: 'Each Item',
  discountPerItemDesc: 'A discount box on every row; the invoice discount is their total.',
  discountBoth: 'Both (Whole + Each Item)',
  discountBothDesc: 'A discount box on every row plus one box for the whole invoice; the invoice discount is the two added together.',
  discountItemsLabel: 'Item Discount',
  discountInvoiceLabel: 'Invoice Discount',
  discountType: 'Discount Type',
  discountTypeDesc: 'How the number typed into any discount box is read.',
  discountTypeAmount: 'Amount (Rs.)',
  discountTypeAmountDesc: 'A flat figure. Typing 200 always cuts Rs. 200.',
  discountTypePercent: 'Percentage (%)',
  discountTypePercentDesc: 'A percentage. Typing 10 cuts 10% of that line (item boxes) or of the subtotal (invoice box).',
  cashInFlow: 'Cash In (+)',
  cashOutFlow: 'Cash Out (-)',
  allCategories: 'All Categories',
  logCashEntryBtn: 'Log Cash Entry',
  customersLabel: 'Customers',
  suppliersLabel: 'Suppliers',
  productsLabel: 'Products',
  employeesLabel: 'Employees',
  customerOutstanding: 'Customer Outstanding',
  supplierOutstanding: 'Supplier Outstanding',
  stockValue: 'Stock Value',
  invoicesLabel: 'Invoices',
  cashInLabel: 'Cash In',
  cashOutLabel: 'Cash Out',
  cashBalanceLabel: 'Cash Balance',
  totalCustomers: 'Total Customers',
  totalSuppliers: 'Total Suppliers',
  totalReceivable: 'Total Receivable',
  totalPayable: 'Total Payable',
  netOutstanding: 'Net Outstanding',
  totalEmployees: 'Total Employees',
  totalPaid: 'Total Paid',
  dailyWage: 'Daily Wage',
  totalInvoices: 'Total Invoices',
  paid: 'Paid',
  unpaid: 'Unpaid',
  totalRevenue: 'Total Revenue',
  productsCount: 'Products',
  totalUnits: 'Total Units',
  totalStockValue: 'Total Stock Value',

  // Form Labels
  companyName: 'Company/Shop Name',
  shopAddressLabel: 'Shop Address',
  officialEmail: 'Official Email',
  contactPhone: 'Contact Phone',
  contactName: 'Contact Name',
  staffName: 'Staff Name',
  baseSalaryLabel: 'Base Salary (Rs.)',
  chooseEmployee: '-- Choose employee --',
  periodStart: 'Period Start',
  periodEnd: 'Period End',
  allowancesLabel: 'Allowances (Rs.)',
  deductionsLabel: 'Deductions (Rs.)',
  itemsSuppliedLabel: 'Items Supplied',
  flowDirection: 'Flow Direction',
  fullName: 'Full Name *',
  purchasePriceLabel: 'Purchase Price (Rs.)',
  salePriceLabel: 'Sale Price (Rs.)',
  amountRs: 'Amount (Rs.)',

  // Placeholders
  phonePlaceholder: 'e.g. 03001234567',
  pinPlaceholder: '****',
  adminPlaceholder: 'admin',
  shopNamePH: 'Al-Rehman General Store',
  ownerNamePH: 'Muhammad Ali',
  emailPH: 'owner@shop.com',
  addressPH: 'Block 4, Sector G-11, Islamabad',
  pinSetupPH: 'e.g. 7890',
  cnicPH: 'e.g. 61101-1234567-1',
  itemsPH: 'e.g. Flour, Eggs, Sugar bags',
  descPH: 'e.g. Grocery order',
  rentPH: 'e.g. Shop rent payment',
  catPH: 'Category name...',
  prodNamePH: 'e.g. Premium Milk Cake',
  skuPH: 'e.g. MC-001',
  unitPH: 'e.g. pcs, kg, box',
  cnicFullPH: '35202-XXXXXXX-X',
  searchDesc: 'Search by description...',
  staffSearchPH: 'Search staff or salary...',
  salarySearchPH: 'Search by employee name...',
  enterCurrentPIN: 'Enter current PIN',
  enterNewPIN: 'Enter new 4-digit PIN',
  confirmNewPINPH: 'Confirm new PIN',
  pricePH: '0.00',

  // Notifications
  loginFailed: 'Login failed. Check your credentials.',
  sessionExpired: 'Session expired. Please enter your PIN again.',
  downloadFailed: 'Download failed. Please try again.',
  popupBlocked: 'Pop-up was blocked. Please allow pop-ups for this site and try again.',
  networkError: 'Cannot reach server. Check network or backend connection.',
  regFailed: 'Registration failed.',
  regNetworkError: 'Cannot reach server. Make sure the backend is running.',
  invalidCredentials: 'Invalid credentials.',
  pinMismatch: 'New PIN and confirm PIN do not match',
  pinLength: 'PIN must be exactly 4 digits',
  pinChanged: 'PIN changed successfully!',
  pinFailed: 'Failed to change PIN',
  renewalSent: 'Renewal request sent! Waiting for admin approval.',
  renewalFailed: 'Failed to send renewal request.',
  partyAdded: '{type} added successfully!',
  udhaarLogged: 'Udhaar transaction logged!',
  cashSaved: 'Cash transaction saved!',
  ieLogged: 'Income/Expense record logged!',
  productAdded: 'Product added to catalog!',
  staffAdded: 'Staff member added!',
  salaryLogged: 'Salary disbursement logged!',
  profileUpdated: 'Company Profile updated!',
  partyUpdated: 'Party updated!',
  cashUpdated: 'Cash entry updated!',
  productUpdated: 'Product updated!',
  entryUpdated: 'Entry updated and balance recalculated!',
  recordUpdated: 'Record updated!',
  staffUpdated: 'Staff information updated!',
  deleted: '{name} deleted.',
  cashDeleted: 'Cash entry deleted.',
  productRemoved: '{name} removed.',
  recordDeleted: 'Record deleted.',
  staffRemoved: 'Staff member removed.',
  transactionDeleted: 'Transaction deleted and balance reversed.',
  selectCustomerFirst: 'Please select a customer for the bill.',
  addItemAtLeast: 'Please add at least one item with a price.',
  invoiceFailed: 'Failed to create invoice. Please try again.',
  invoiceCreated: 'Invoice created! Ready to print.',
  incorrectPin: 'Incorrect PIN. Please try again.',
  salaryPaidTo: 'Salary paid to {name}',

  // Delete confirmations
  deleteCustomer: 'Delete customer "{name}"?',
  deleteSupplier: 'Delete supplier "{name}"?',
  deleteTransaction: 'Delete this Rs.{amount} transaction?',
  removeProduct: 'Remove "{name}" from catalog?',
  removeStaff: 'Remove "{name}" from staff?',
  deleteRecord: 'Delete this {type} record?',
  deleteCashEntry: 'Delete this cash entry?',

  // Print Reports
  cashBook: 'CASH BOOK',
  incomeExpense: 'INCOME & EXPENSE',
  ledgerStatement: 'LEDGER STATEMENT',
  customerDirectory: 'CUSTOMER DIRECTORY',
  supplierDirectory: 'SUPPLIER DIRECTORY',
  stockInventory: 'STOCK INVENTORY',
  staffSalaryReport: 'STAFF & SALARY REPORT',
  invoiceSummaryReport: 'INVOICE SUMMARY',
  businessOverview: 'BUSINESS OVERVIEW',
  paymentReceipt: 'PAYMENT RECEIPT',
  salarySlip: 'SALARY SLIP',
  reportDate: 'Report Date',
  period: 'Period',
  statementDate: 'Statement Date',
  totalCashIn: 'Total Cash In',
  totalCashOut: 'Total Cash Out',
  netBalance: 'Net Balance',
  totalIncome: 'Total Income',
  totalExpenses: 'Total Expenses',
  netProfit: 'Net Profit',
  netLoss: 'Net Loss',
  closingBalance: 'Closing Balance',
  surplus: '(Surplus)',
  deficit: '(Deficit)',
  receivable: '(Receivable)',
  payable: '(Payable)',
  totals: 'TOTALS',
  closingBal: 'CLOSING BALANCE',
  totalOutstanding: 'TOTAL OUTSTANDING',
  totalInventoryValue: 'TOTAL INVENTORY VALUE',
  totalMonthlyPayroll: 'TOTAL MONTHLY PAYROLL',
  totalInvoiceRevenue: 'TOTAL INVOICE REVENUE',
  partyDetails: 'Party Details',
  balanceSummary: 'Balance Summary',
  receivableToGet: 'Receivable (To Get)',
  payableToGive: 'Payable (To Give)',
  employeeDetails: 'Employee Details',
  netSalaryPaid: 'Net Salary Paid',
  employeeSignature: 'Employee Signature',
  authorizedSignatory: 'Authorized Signatory',
  companyNameLabel: 'Company Name',
  myBusiness: 'My Business',
  yourCompany: 'Your Company Name',
  companyAddress: 'Company Address',
  from: 'From',
  to: 'To',
  entry: 'Entry',
  gaveUdhaar: 'Gave (Udhaar)',
  gotPayment: 'Got (Payment)',
  signatureLine: '___________________________',

  // Tab filter buttons
  filterAll: 'All Time',
  filterDaily: 'Daily',
  filterWeekly: 'Weekly',
  filterMonthly: 'Monthly',
  filterYearly: 'Yearly',
  filterCustom: 'Custom',
  fromDate: 'From Date',
  toDate: 'To Date',
  fromTime: 'From Time',
  toTime: 'To Time',
  clearFilters: 'Clear',
  deleteLogConfirm: 'Delete this log entry?',

  // Empty states
  noLogsFound: 'No logs found.',
  noResults: 'No results found.',

  // Misc
  syncStatus: 'synced',
  unsaved: 'unsaved',
  rs: 'Rs.',
  selectDate: 'Select date',
  darkMode: 'Dark Mode',
  lightMode: 'Light Mode',
  whatsappMsg: 'Dear {name}, your outstanding balance in {biz} is Rs. {amount}. Please clear it soon.',

  // Dashboard card subtitles & labels
  allTimeComparison: 'All time comparison',
  cashRecPayables: 'Cash, receivables & payables',
  receivablesLabel: 'Receivables',
  payablesLabel: 'Payables',
  activeShop: 'Active Shop',
  settled: 'Settled',
  get: 'Get',
  give: 'Give',
  low: '(Low)',
  staffProductsInvoices: '{staffCount} staff · {productCount} products · {invoiceCount} invoices',

  // Print Report headers
  balance: 'Balance',
  customerDetails: 'Customer Details',
  summary: 'Summary',
  totalDue: 'Total Due',
  pendingOnLedger: 'PENDING ON LEDGER',
  slipRef: 'Slip Ref',
  dateIssued: 'Date Issued',
  employmentType: 'Employment Type',
  payPeriod: 'Pay Period',
  basicSalary: 'Basic Salary',
  printReceipt: 'Print Receipt',
  backToLedger: 'Back to Ledger',
  backToBillBook: 'Back to Bill Book',
  printInvoice: 'Print Invoice',
  backToStaff: 'Back to Staff',
  printSalarySlip: 'Print Salary Slip',

  // Title attributes
  editCompanyInfo: 'Edit Company Info',
  toggleTheme: 'Toggle Theme',
  lockSession: 'Lock Session',
  toggleLanguage: 'Toggle Language',
  printIEReport: 'Print Income/Expense Report',
  printStockReport: 'Print Stock Inventory Report',
  printStaffReport: 'Print Staff & Salary Report',
  printInvoiceReport: 'Print Invoice Summary Report',
  generateSalarySlip: 'Generate Salary Slip',
  sendSalarySlipWA: 'Send Salary Slip via WhatsApp',
  sendInvoiceWA: 'Send Invoice via WhatsApp',
  sendWhatsApp: 'Send WhatsApp Message',

  // Staff directory
  ofEmployees: 'of',

  // Login placeholders
  phoneExamplePH: 'e.g. 03001234567',
  addressExamplePH: 'Block 4, Sector G-11, Islamabad',
  adminExamplePH: 'admin',
  pinExamplePH: 'e.g. 7890',

  // WhatsApp Templates
  waTemplatesTitle: 'WhatsApp Message Templates',
  waTemplatesDesc: 'Customize the messages sent via WhatsApp to customers, suppliers and employees.',
  waBalanceReminder: 'Balance Reminder',
  waBalanceReminderDesc: 'Sent to customers/suppliers to remind of outstanding balance',
  waTransactionReceipt: 'Transaction Receipt',
  waTransactionReceiptDesc: 'Sent after each ledger entry as a receipt',
  waInvoiceMessage: 'Invoice Message',
  waInvoiceMessageDesc: 'Sent to customers with invoice and balance details',
  waSalarySlip: 'Salary Slip',
  waSalarySlipDesc: 'Sent to employees with salary breakdown',
  waAvailableVars: 'Available Variables (click to insert)',
  waPreview: 'Live Preview',
  waResetDefault: 'Reset to Default',
  waShareModeTitle: 'WhatsApp Share Format',
  waShareModeDesc: 'Choose what gets sent when you tap any WhatsApp button in the app.',
  waShareModeText: 'Text Message',
  waShareModeTextDesc: 'Sends the editable text template shown below.',
  waShareModeImage: 'Image Card',
  waShareModeImageDesc: 'Sends a branded card image built from your own data.',
  waShareModePreview: 'Image Card Preview',
  waYouGave: 'You Gave',
  waYouGot: 'You Received',
  waRunningBalance: 'Running Balance',
  waCardDownloaded: 'Card image downloaded! Attach it in the opened WhatsApp chat.',
  waCardCopied: 'Card image copied! Paste it into the WhatsApp chat with Ctrl+V.',
  waCardFallback: 'The image could not be created, so the text message was sent instead.',

  // Stock Tab Toggle & History
  stockTab: 'Stock',
  stockHistoryTab: 'Stock History',
  stockHistory: 'Stock History & Supplier Logs',
  stockHistoryDesc: 'Track where stock was added, including supplier names and purchase invoices.',
  noStockMovements: 'No stock movements logged yet.',
  stockIn: 'Stock In',
  stockOut: 'Stock Out',
  adjustment: 'Adjustment',
  supplierOrDesc: 'Supplier / Description',
  product: 'Product',
  typeNewProduct: 'Type above to add as a new product',
  unknownProduct: 'Unknown Product',
  salePrice: 'Retail Price',
  purchasePrice: 'Purchase Price',
  unit: 'Unit Quantity',
  subtotal: 'Subtotal',
  categoryReport: 'Category Report',
  expenses: 'Expenses',
  transactions: 'Transactions',
  addNewProductLabel: 'Add "{name}" as new product',

  // Business Card Designer
  businessCardDesigner: 'Business Card Designer',
  selectTemplate: 'Select Template',
  minimalist: 'Minimalist Elegant',
  modernDark: 'Modern Tech (Dark)',
  creativeGradient: 'Creative Gradient',
  organicGreen: 'Organic Green',
  navyGoldLuxury: 'Navy Gold Luxury',
  mandala: 'Mandala Cultural',
  cardDetails: 'Card Details',
  companyName: 'Company Name',
  companyTagline: 'Company Tagline / Features',
  personName: 'Your Name',
  tagline: 'Tagline / Role',
  primaryColor: 'Primary Color',
  printSingle: 'Print Single Card',
  printGrid: 'Print Grid (10 Cards)',
  brandLogo: 'Brand Logo',

  // Bulk / Big Unit & Packaging
  bigUnitBulk: 'Packaging / Big Unit (Optional)',
  bulkUnitName: 'Packaging Unit (e.g. Carton, Box)',
  unitsPerBulk: 'Pieces per Package',
  bulkPurchasePrice: 'Package Purchase Cost',
  bulkSalePrice: 'Package Sale Price',
  pieceCost: 'Cost per Piece',
  piecePrice: 'Price per Piece',
  packageCost: 'Package Cost',
  packagePrice: 'Package Price',
  packagesCount: 'Packages',
  loosePieces: 'Loose Pieces',
  totalPieces: 'Total Pieces',
  packagingHelper: '1 {bulk} = {count} pcs',

  // Print Customization
  printCustomizationTitle: 'Invoices & Reports Print Customization',
  printCustomizationDesc: 'Configure which fields to show or hide on printed invoices, adjust header and logo layouts, customize footer messages, and set custom report notes.',
  invoicesPrintTab: 'Invoice Print Settings',
  reportsPrintTab: 'Reports Print Notes',

  // Layout & Branding
  headerAndLayout: 'Header & Layout',
  logoPosition: 'Logo Position',
  logoLeft: 'Left',
  logoCenter: 'Center',
  logoRight: 'Right',
  logoNone: 'Hidden',
  headerLayout: 'Header Style',
  headerStandard: 'Standard (Split)',
  headerCentered: 'Centered (Stacked)',
  itemsPosition: 'Sections Order',
  itemsStandard: 'Customer Details First',
  itemsFirst: 'Items Table First',

  // Field visibility
  fieldVisibility: 'Fields & Columns Visibility',
  showSerialNumber: 'Serial Number (S.N) Column',
  showSerialNumberDesc: 'Show or hide the S.N row counter in invoice items table',
  showSubtotal: 'Subtotal Amount',
  showSubtotalDesc: 'Show subtotal calculation before discounts',
  showDiscount: 'Discount Row',
  showDiscountDesc: 'Show discount deduction when applicable',
  showPaidAmount: 'Paid Amount',
  showPaidAmountDesc: 'Show the amount paid by the customer',
  showRemainingBalance: 'Remaining Balance',
  showRemainingBalanceDesc: 'Show outstanding balance on this invoice',
  showPartyPhone: 'Customer/Supplier Phone',
  showPartyPhoneDesc: 'Display customer or supplier contact number',
  showPartyCnic: 'Customer/Supplier CNIC',
  showPartyCnicDesc: 'Display CNIC number if available',
  showPartyAddress: 'Customer/Supplier Address',
  showPartyAddressDesc: 'Display address on printed receipt',
  showBusinessAddress: 'Business Address in Header',
  showBusinessAddressDesc: 'Display your company address in the header',
  showBusinessPhoneEmail: 'Business Phone & Email in Header',
  showBusinessPhoneEmailDesc: 'Display your contact information in the header',
  showInvoiceTime: 'Time on Invoice Date',
  showInvoiceTimeDesc: 'Include exact time alongside the date',
  showSignatureBlock: 'Signature Lines',
  showSignatureBlockDesc: 'Add customer and authorized signature boxes at the bottom',
  customerSignature: 'Customer Signature',
  authorizedSignature: 'Authorized Signature',

  // Footer note / End message
  invoiceFooterNote: 'Invoice End Message / Note',
  enableInvoiceNote: 'Show Message/Note at bottom of Invoice',
  noteTitleLabel: 'Message Heading / Label',
  noteTitlePlaceholder: 'e.g. Note:, Terms & Conditions:, Important:',
  noteTextLabel: 'Message Content',
  noteTextPlaceholder: 'Enter custom terms, return policy, or thank you message...',
  quickPresets: 'Quick Presets',
  presetThankYou: 'Thank you for your business!',
  presetNoReturn: 'Goods once sold will not be returned or exchanged.',
  presetTerms: 'Payment due within 15 days. Warranty valid with invoice.',

  // Reports print notes
  reportsNotesTitle: 'Reports Notes & Messages',
  reportsNotesDesc: 'Add a custom note, terms, or message at the bottom of printed reports. You can define a global note or customize notes per tab.',
  enableReportNote: 'Show Notes on Printed Reports',
  globalReportNote: 'Global Report Note (Applies to all reports)',
  globalReportNotePlaceholder: 'e.g. Confidential document for internal accounting use only.',
  tabSpecificNotes: 'Tab-Specific Custom Notes (Overrides global note)',
  selectTabToCustomize: 'Select Section to Customize',
  tabNoteTitlePlaceholder: 'e.g. Remarks, Note, Instructions',
  tabNoteTextPlaceholder: 'Custom message for this specific report...',
  resetPrintSettings: 'Reset to Defaults',
  previewInvoice: 'Preview Invoice',
  closePreview: 'Close Preview',
  previewNotice: 'This is a sample preview based on your current customization settings.',

  // Custom Table Column Headers
  customColumnHeaders: 'Custom Table Column Headers',
  customColumnHeadersDesc: 'Customize the column header titles printed on your invoices. Leave blank to use default names.',
  colSerialNo: 'Serial No. (S.N)',
  colItemDescription: 'Product / Item Name',
  colQuantity: 'Quantity (Qty)',
  colUnitPrice: 'Unit Price / Rate',
  colSubtotal: 'Total / Amount',
  packagingHeadersOptional: 'Packaging / Bulk Headers (Optional)',
  colBulkQuantity: 'Packaging Unit (e.g. CTN)',
  colSmallQuantity: 'Loose Pieces (PC)',
  colBulkPrice: 'Packaging Cost / Price',
  colSmallPrice: 'Piece Cost / Price',
  resetColumnNames: 'Reset column names to defaults',

  // ── Key-sync repairs ─────────────────────────────────────────────────────
  // These keys were called by t() but never defined here, so the UI rendered
  // the raw key (t() falls back to the key itself). The text matches the
  // inline `|| '…'` fallbacks in App.jsx, which never fired because a
  // missing key returns a truthy string.
  addBoth: 'Add Customer/Supplier',
  addItem: 'Add Item',
  allBankAccounts: 'All Banks',
  allTransactionTypes: 'All Types',
  bankOnline: 'Bank / Online',
  bankTransaction: 'Bank transaction',
  both: 'Both',
  cashEntry: 'Cash entry',
  companyLogo: 'Company Logo',
  deleteDuplicateEntry: 'Delete this duplicate entry?',
  deleteMovement: 'Delete movement on {date}?',
  deposits: 'Deposits',
  designs: 'Designs',
  duplicateEntryFound: 'Duplicate entry found',
  duplicateEntryMessage: 'These records have exactly the same details. The first record will be kept.',
  editStockMovement: 'Edit Stock Movement',
  enterBankName: 'Enter bank name',
  entries: 'entries',
  error: 'Error',
  general: 'General',
  incomeByCat: 'Income/Expense by Category',
  invoices: 'Invoices & Daybook',
  keep: 'Keep',
  loss: 'Loss',
  note: 'Note',
  other: 'Other',
  overview: 'Business Overview Dashboard',
  party: 'Party',
  printBusinessOverview: 'Print Business Overview',
  printCustomerDirectory: 'Print Customer Directory',
  printSupplierDirectory: 'Print Supplier Directory',
  profit: 'Profit',
  remove: 'Remove',
  set: 'Set',
  stockMovement: 'Stock movement',
  totalEntries: 'Total Entries',
  transaction: 'Ledger transaction',
  website: 'Website',
  withdrawals: 'Withdrawals'
};

export default en;
